import {
  HomeIcon,
  MapPinIcon,
  CurrencyDollarIcon,
  Cog6ToothIcon,
} from '@heroicons/react/24/outline';
import { PolygonIcon } from '@/components/icons/PolygonIcon';
import type { ProductConfig } from '../registry';

export default {
  slug: 'polygon',
  icon: PolygonIcon,
  accentColor: {
    bg: 'bg-cyan-500/10',
    border: 'border-cyan-500/30',
    text: 'text-cyan-400',
  },
  navigation: [
    { name: 'PORTFOLIO', href: '/polygon/dashboard', icon: HomeIcon },
    { name: 'SITES', href: '/polygon/sites', icon: MapPinIcon },
    { name: 'ALLOCATION', href: '/polygon/capital', icon: CurrencyDollarIcon },
    { name: 'SETTINGS', href: '/polygon/settings/costs', icon: Cog6ToothIcon },
  ],
  landingPage: '/polygon/dashboard',
} satisfies ProductConfig;
